const MoviePageAppView = () =>
  import(
    // @ts-ignore
    /*webpackChunkName: "MoviePageAppView"*/ "@/views/app/MoviePageApp.vue"
  );

const episode = {
  path: "series/:slug/season-:season/episode-:episode",
  name: "episode",
  props: (route: { params: { slug: any; season: any; episode: any } }) => ({
    slug: route.params.slug,
    season: route.params.season,
    episode: route.params.episode,
    type: "episode",
  }),
  component: MoviePageAppView,
  meta: { requiresAuth: false, requiresEntitlement: false, entrypoint: true },
};
export default episode;
